import { createAsyncAction, createAction } from "typesafe-actions";

export const loadMailContactAsync = createAsyncAction("LOAD_MAIL_CONTACT_REQUEST", "LOAD_MAIL_CONTACT_SUCCESS", "LOAD_MAIL_CONTACT_FAILURE")<
    void,
    string,
    string
>();